import React, { useEffect } from 'react';

interface MenuProps {
  children: React.ReactNode;
  className?: string;
  onClose?: () => void;
}

export const Menu: React.FC<MenuProps> = ({ children, className = '', onClose }) => {
  // Simple click outside handler
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (onClose) onClose();
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [onClose]);

  return (
    <div
      className={`absolute bg-dark-surface border border-dark-border/30 shadow-xl rounded-md py-1 min-w-[200px] animate-in fade-in zoom-in-95 duration-100 overflow-y-auto ${className}`}
      style={{ maxHeight: '80vh', zIndex: 99999 }}
      onMouseDown={(e) => e.stopPropagation()} // Prevent closing immediately when clicking inside
    >
      {children}
    </div>
  );
};
